import React from "react";

import PageBuild from "../../components/template-parts/page-build";

export default ({ pageContext }) => <PageBuild data={pageContext} />;
